import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { useListProductTags } from "./service/product-tags-api";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { SpinnerBlock } from "../common/Spinner";
import { EmptyState } from "../../components/EmptyState";
import { Divider } from "../../components/Divider";
import { ProductTagsTable } from "./components/ProductTagsTable";
import { CreateProductTagSelector } from "./components/MutateProductTagSelector";
import { useSearchParamsManipulation } from "../../hooks/use-searchparams-manipulation";
import { MutateProductTagDrawer } from "./components/MutateProductTagDrawer";

export const ProductTagsList = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { option, removeOption } = useSearchParamsManipulation();

  const { data, isLoading } = useListProductTags(organizationKeyName);

  if (isLoading) {
    return <SpinnerBlock />;
  }

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="Product tags"
          subtitle="Manage all of your product tags"
        >
          <CreateProductTagSelector />
        </PageHeader>
        {data?.length === 0 || !data ? (
          <div>
            <Divider />
            <EmptyState
              title="No product tags created yet"
              subtitle="Create your first product tag by pressing on create product tag in top right corner"
            />
          </div>
        ) : (
          <ProductTagsTable productTags={data} />
        )}
      </CardContainer>
      <MutateProductTagDrawer
        isOpen={!!option}
        onClose={removeOption}
        tag={data?.find((tag) => tag.id === option)}
      />
    </PageWrapper>
  );
};
